module.exports = __webpack_public_path__ + "static/artist-development-hero-mobile-9dd6f8ad17c15938e04282f5c62ff220.webp";